import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    WORKING_HOURS: "api/WorkingHoursReport",
    WORKING_HOURS_EXPORT: "api/GC/WorkingHoursReport",
}

const getWorkingHours = async (data: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.WORKING_HOURS, data);
    return res.data;
};

const getWorkingHoursReport = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.WORKING_HOURS_EXPORT, data, { responseType: "arraybuffer" });
    return res;
};

const getWorkingHoursEmailReport = async (data: any) => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.WORKING_HOURS_EXPORT, data);
    return res;
};

const WorkingHoursService = {
    getWorkingHours,
    getWorkingHoursReport,
    getWorkingHoursEmailReport,
};

export default WorkingHoursService;